// var createRefBasicModel = require('../baseRefModel');
import createRefBasicModel from '../baseRefModel'
var {BASEHOST_REPORT} = require("../../../../pub/config/baseHost");

function createModel() {
    var model = new Object();
    var base = createRefBasicModel();
    function Model(){}
    Model.prototype = base;
    var model = new Model();
    model.baseModel = base;
    /***** 以上为固定代码，勿动, baseModel内方法自动继承过来，可用base调用  *****/
    model.refConfig = {
    	refName:'菜品类别参照',
    	refType:'tree',
      refDetail:'基本的菜品类别树参照'
    }

	model.getRefFields = function(){
		return {
			id:'id',
			code:'dishTypeCode',
			name:'dishTypeName'
		}
	};

	model.getClassData = function(callback){
		var _self = this;
        const url = BASEHOST_REPORT + "/listDishType";
        const params = {
        };
        base.ajax.getJson(url,params,function(data){

            var withchilddata = _self.formatChildData(data.data);
            //手动添加一个根级别
            var potType ={
                dishTypeName:'锅底类',
                dishTypeCode:'1',
                id:'1',
                relateId:'1',
                sortNo:'1'
            };
            withchilddata.push(potType);
            var treedata = [{
                id:"root",
                key:"root",
                dishTypeName:"菜品分类",
                children: withchilddata
            }];
            callback(treedata);
        });
	};

    model.getOne = function(value, callback){
        const params ={
            dishTypeId: value
        }

        const url = BASEHOST_REPORT + "/getDishType";

        base.ajax.getJson(url,params,function(data){
            callback(data.dishTypeName);
        });
    }

    model.getListByPks = function(value, callback){
      
        const params ={
            ids: value.join(",")
        }

        const url = BASEHOST_REPORT + "/getDishTypeListByIds";

        base.ajax.postJson(url,params,function(data){
            callback(data);
        });
    }
    //格式化子表结构
    model.formatChildData = function(datas){
        var treelevelstart = 1;
        var that = this;
        if (!datas || datas.length==0) return datas;
        var parentfield = "parentId"; //this.props.parentfield;
        var checkchildren = this.checkchildren?this.checkchildren
                        :function(okey, odata){return (odata[that.childfield?that.childfield:'id'] == okey)};

        var withchilddata = {};
        var withparentdata = [];
        var rootdatas = [];
        //var nullchilddata = [];
        for(var i = 0; i < datas.length; i++){
            var odata = datas[i];
            if(!odata[parentfield]){
                //withchilddata[odata]=odata;
            }else {
                if (!withchilddata[odata[parentfield]]) {
                    withchilddata[odata[parentfield]] = [];
                }
                withchilddata[odata[parentfield]].push(odata);
            }
        }
        for(var i = 0; i < datas.length; i++){
            var odata = datas[i];
            for(var okey in withchilddata){
                var rows = withchilddata[okey];
                if(okey != rows){
                    if(checkchildren(okey, odata)){
                        odata.children = rows;
                        delete withchilddata[okey];
                        break;
                    }
                }
            }
        }
        for(var okey in withchilddata){
            withparentdata = withparentdata.concat(withchilddata[okey]);
        }
        for(var i = 0; i < datas.length; i++){
            var odata = datas[i];
            if(!odata[parentfield]){
                rootdatas.push(odata);
            }else{
                for(var j = 0; j<withparentdata.length; j++){
                    if(odata == withparentdata[j]){
                        rootdatas.push(odata);
                        withparentdata.splice(j,1);
                    }
                }
            }
        }
        //重置级别值
        var setlevel = function(node){
            if(node.children){
                for(var i = 0; i<node.children.length;i++){
                    node.children[i]._level = node._level + 1;
                    setlevel(node.children[i]);
                }
            }
        }
        for(var i = 0; i < rootdatas.length; i++){
            rootdatas[i]._level = treelevelstart;
            setlevel(rootdatas[i]);
        }

        return rootdatas;
    };

    return model;
}

export default createModel;



// WEBPACK FOOTER //
// ./src/pub/components/baseRef/model/dishClassReportModel.js